import React, { useMemo, useRef, useState } from 'react'

import { NewAnonceCard } from '../UI/NewAnonceCard/NewAnonceCard'
import { NewAnonceListProps } from './NewAnonceList.types'

const startItems = 3

export const NewAnonceList = (props: NewAnonceListProps) => {
  const { items, title, category, id, exclude, currentPage } = props
  const [itemsCount, setItemsCount] = useState<number | undefined>(startItems)
  const [isOpen, setIsOpen] = useState(false)
  const sectionRef = useRef<HTMLOptionElement>(null)

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  const filteredReversedData = useMemo(() => {
    const filteredItems = items.filter(item => item.id !== exclude)
    return filteredItems.reverse()
  }, [items, exclude])

  const showMore = () => {
    setItemsCount(isOpen ? startItems : undefined)
    setIsOpen(!isOpen)

    if (isOpen && sectionRef.current) {
      window.scrollTo(0, sectionRef.current.offsetTop)
    }
  }

  return (
    <section className='section' id={id} ref={sectionRef}>
      <div className='new-anonce-list'>
        <h2 className='section__title'>{title}</h2>
        <div className='new-cards'>
          <div className='new-cards__items new-cards__items--3'>
            {filteredReversedData.slice(0, itemsCount).map(item => {
              if (exclude && item.id === exclude) {
                return null
              }
              return (
                <div key={item.id}>
                  <NewAnonceCard
                    {...item}
                    category={category}
                    currentPage={currentPage}
                  />
                </div>
              )
            })}
          </div>
          {items.length > startItems && (
            <div className='new-cards__btn'>
              <button className='btn btn--gray' onClick={showMore}>
                {isOpen ? 'Скрыть все' : 'Показать все'}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
